/**
 * Record Edit Page
 *
 * Edit form for an existing entity record.
 */

import { Typography, useI18n } from '@ops-matrix/design-system-ui';
import { useNavigate, useParams } from 'react-router-dom';
import EntityRecordForm from '../../components/entity/EntityRecordForm';
import { PageTemplate } from '../../components/layout/PageTemplate';

export default function RecordEditPage() {
  const { entityId, recordId } = useParams<{ entityId: string; recordId: string }>();
  const navigate = useNavigate();
  const { t } = useI18n();

  if (!entityId || !recordId) {
    return (
      <PageTemplate variant="form">
        <Typography color="error" sx={{ textAlign: 'center', py: 4 }}>
          {t('consumer.record.notFound')}
        </Typography>
      </PageTemplate>
    );
  }

  const handleSuccess = () => {
    navigate(`/records/${entityId}/${recordId}`);
  };

  const handleCancel = () => {
    navigate(`/records/${entityId}/${recordId}`);
  };

  return (
    <PageTemplate variant="form">
      <EntityRecordForm
        entityId={entityId}
        mode="edit"
        recordId={recordId}
        onSuccess={handleSuccess}
        onCancel={handleCancel}
      />
    </PageTemplate>
  );
}
